import {Component} from "../Components/Component";
import {fetchPage} from "../util/ajax";
import {delayPromise} from "../util/promise";
import {createLogger} from "../util/logger";
import {filterEventSelector} from "../util/event";
import gsap, {Power3} from "gsap";
import {ScrollAnimations} from "../Components/ScrollAnimations";
import {getParent} from "../util/dom";
import {AjaxNavigation} from "../Components/AjaxNavigation.js";

const console = createLogger("EventsPage");

export class EventsPage extends Component {
    static name = "events-page";

    static EVENT_PAGE_LOADED = "events-page:page-loaded";


    eventDetailsOverlayTweenDefaults = {
        duration: 0.5,
        ease: Power3.easeOut,
    };

    get name() {
        return EventsPage.name;
    }

    constructor(el) {
        super(el);

        this.init();
    }

    init() {
        /**
         * @type {HTMLFormElement}
         */
        this.$form = this.$("form");

        /**
         * @type {HTMLElement}
         */
        this.$nextPageLink = this.$("nextPageLink");

        /**
         * @type {HTMLElement}
         */
        this.$eventDetailsOverlay = this.$("eventDetailsOverlay");
        this.$eventDetailsOverlayContent = this.$("eventDetailsOverlayContent");

        /**
         *
         * @type {HTMLElement[]}
         */
        this.$eventDetailsBtns = this.$("btnEventDetails");

        /**
         * @type {HTMLElement}
         */
        this.$target = this.$("target");

        this.addEventListener(this.$form, "submit", this.onSubmitForm.bind(this));

        this.addEventListener(this.el, "click",
            filterEventSelector(this.getAttributeSelector("nextPageLink"), this.onClickNextPage.bind(this))
        );

        console.log(this.getAttributeSelector("event") + " a");
        this.addEventListener(this.el, "click",
            filterEventSelector(this.getAttributeSelector("event") + " a", this.onClickEventDetails.bind(this))
        );

        // this.addEventListener(this.querySelectorAll("a"), "click", (e) => {
        //     e.stopPropagation();
        //     e.preventDefault();
        // });

        this.addEventListener(this.$eventDetailsBtns, "click", this.onClickEventDetails.bind(this));

        this.addEventListener(this.$eventDetailsOverlayContent, "click", filterEventSelector(".event-details-overlay__close", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hideEventDetailsOverlay();
        }));

        this.addEventListener(window, "popstate", (e) => {
            if (this.overlayVisible) {
                this.hideEventDetailsOverlay();
            }
        });

        console.log(this);
    }

    /**
     * Handles click on event details link
     * @param {MouseEvent} e
     */
    onClickEventDetails(e) {
        e.preventDefault();
        e.stopPropagation();

        const url = getParent(e.target, "a")?.getAttribute("href");

        console.log("onClickEventDetails", url);

        if (!url?.length) return;

        fetchPage(url).then((html) => {
            const content = html.querySelector(".site-wrapper");

            this.$eventDetailsOverlayContent.replaceChildren(content);

            this.showEventDetailsOverlay();
        });
    }

    showEventDetailsOverlay() {
        this.overlayVisible = true;
        gsap.set(document.body, {overflow: "hidden"});

        const tl = gsap.timeline();
        tl.to(this.$eventDetailsOverlay, {
            ...this.eventDetailsOverlayTweenDefaults,
            top: "-=100%",
            opacity: 1,
            onComplete: () => {
            }
        });
        tl.add(() => {
            console.log("triggerScrollAnimations");
            ScrollAnimations.updateAnimations(this.$eventDetailsOverlayContent);
        }, "-=0.3");
    }

    hideEventDetailsOverlay() {
        this.overlayVisible = false;
        gsap.set(document.body, {overflow: ""});
        gsap.to(this.$eventDetailsOverlay, {
            ...this.eventDetailsOverlayTweenDefaults,
            top: "+=100%",
            opacity: 0,
        });
    }

    /**
     * @param {MouseEvent<HTMLAnchorElement>} e
     */
    onClickNextPage(e) {
        e.preventDefault();
        e.stopPropagation();


        const url = this.$("nextPageLink").getAttribute("href");
        console.log("onClickNextPage", e, url);

        this.loadPage(url);
    }

    /**
     *
     * @param {SubmitEvent} e
     */
    onSubmitForm(e) {
        e.preventDefault();

        const data = new FormData(e.target);
        const params = [...data.entries()].reduce((all, [name, value]) => {
            if (!value.length) return all;
            return {
                ...all,
                [name]: value
            };
        }, {});

        const month = this.$form.querySelector(`[name="month"]`).getAttribute("data-value");
        if (month.trim().length) {
            params["month"] = month;
        }

        console.log("onSubmitForm", {data, params});

        window.history.pushState({}, null, `${this.$form.action}?${new URLSearchParams(params)}`);
        this.loadPage(this.$form.action, params, true);
    }

    loadPage(url, searchParams, replace = false) {
        const _url = url + (searchParams ? "?" + (new URLSearchParams(searchParams)).toString() : "");
        console.log("loadPage", {url, _url, searchParams});

        // Show loader
        document.body.classList.add("loader--visible");

        // Fetch Page
        delayPromise(0, fetchPage(_url)).then((html) => {

            let $source = html.querySelector(this.getAttributeSelector("target"));


            console.log("loadPage.result", {name: this.getAttributeSelector("target"), $source, html});


            if ($source) {
                if (replace) {
                    console.log("replace", {$target: this.$target, $source});
                    this.$target.replaceChildren(...$source.children);
                } else {
                    console.log("append", {$target: this.$target, $source});
                    this.$target.append(...$source.children);
                }
            }

            const $replaceSource = Array.from(html.querySelectorAll(`[data-events-page-replace]`));

            $replaceSource.forEach((sourceElement) => {
                const name = sourceElement.getAttribute("data-events-page-replace");
                if (!name.length) return;

                const targetElement = this.el.querySelector(`[data-events-page-replace="${name}"]`);

                if (targetElement) {
                    console.log("replace", {targetElement, sourceElement})
                    targetElement.replaceChildren(...sourceElement.children);
                }
            });

            document.body.classList.remove("loader--visible");

            document.body.dispatchEvent(new CustomEvent(EventsPage.EVENT_PAGE_LOADED));
        });
    }

}
